import React from 'react';
import { Link } from 'react-router-dom';

const LegalPage = () => (
  <div className="min-h-screen pt-24 pb-20" data-testid="legal-page">
    <div className="bg-[#000000] py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-white font-['Playfair_Display']">Mentions Légales</h1>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-lg max-w-none">
      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">1. Éditeur du site</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Le site <strong>calvi-fishing.com</strong> est édité par :<br />
        <strong>CALVI FISHING</strong><br />
        SASU, société par actions simplifiée unipersonnelle<br />
        Chemin Notre Dame de la Serra, 20260 Calvi<br />
        SIRET : 94288448700011<br />
        Numéro de TVA : FR01942884487<br />
        Téléphone : 06 44 38 34 06<br />
        Email : contact@calvi-fishing.com<br /><br />
        Responsable de la publication : <strong>Webisula</strong><br />
        Email : webisula@gmail.com
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">2. Hébergement</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Le Site est hébergé sur les serveurs de <strong>OVH</strong><br />
        SAS au capital de 10 069 020 euros<br />
        Siège social : 2 rue Kellermann - 59100 Roubaix - France<br />
        RCS : Roubaix / Tourcoing 424 761 419 00011<br />
        Téléphone : 08 203 203 63 - 0.118 euros/mn
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">3. Propriété intellectuelle</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        L'ensemble du contenu du site calvi-fishing.com (textes, images, photographies, vidéos, logos, marques) est protégé par le droit d'auteur et le droit de propriété intellectuelle. Toute reproduction, représentation, modification, publication, transmission ou dénaturation, totale ou partielle, du site ou de son contenu est strictement interdite sans autorisation écrite préalable de CALVI FISHING.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">4. Responsabilité</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        CALVI FISHING s'efforce de fournir sur le site des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait de tiers. Les sorties en mer sont soumises aux conditions météorologiques et peuvent être annulées ou reportées pour des raisons de sécurité.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">5. Cookies</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Le site calvi-fishing.com utilise des cookies nécessaires au bon fonctionnement du site et à l'amélioration de l'expérience utilisateur. En poursuivant votre navigation, vous acceptez l'utilisation de ces cookies.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">6. Droit applicable</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Les présentes mentions légales sont régies par le droit français. Tout litige relatif à l'utilisation du site sera soumis à la compétence exclusive des tribunaux de Bastia.
      </p>

      <div className="flex gap-4 mt-10 pt-8 border-t border-[#E2E8F0]">
        <Link to="/cgv" className="text-[#b7ede0] hover:underline font-medium">CGV</Link>
        <Link to="/privacy" className="text-[#b7ede0] hover:underline font-medium">Politique de confidentialité</Link>
      </div>
    </div>
  </div>
);

export default LegalPage;
